<template>
    <b-modal v-model="showForm" no-close-on-backdrop no-enforce-focus :title="$t('updatePackageExt')">
      <p v-if="formModel.packageLimit"><span>{{$t('numberOfUserCanBeSelectedMaximum')}}</span>: <b>{{formModel.packageLimit}}</b></p>
      <label v-if="formModel.packageExts">{{$t('selectedUsers')}}: <b>{{ formModel.packageExts.length }}</b></label>
      <user-tree-select multiple field="ext" attribute="packageExts" :model="formModel" :errors="formErrors" :label="null"
                        :auto-load-root-options="true"></user-tree-select>
      <template v-slot:modal-footer>
        <button class="btn btn-secondary float-right" @click="showForm = false">{{ $t('cancel') }}</button>
        <button class="btn btn-primary float-right" @click="updateExt"
                :disabled="saveLoading || !formModel.packageExts || !formModel.packageExts.length || formModel.packageExts.length > formModel.packageLimit">
          <b-spinner v-if="saveLoading" small></b-spinner>
          {{ $t('save') }}
        </button>
      </template>
    </b-modal>
</template>
<script>

import UserTreeSelect from "../../../../components/UserTreeSelect";
import CRUD from "../../../../mixins/CRUD";

export default {
  props: ['loadingModel'],
  mixins: [CRUD],
  components: {UserTreeSelect},
  data() {
    return {
      showForm: false,
      service: '/number',
      phoneNumberId: null
    }
  },
  methods: {
    update: function (id) {
      this.loadingModel.loading = true;
      this.$emit('updateExtOn');
      let uri = this.service;
      if (id) {
        uri += '/' + id;
      }
      this.updateLoading = true;
      this.phoneNumberId = id;
      this.$service.get(uri).then(response => {
        this.formModel = {};
        this.formTitle = this.$t('update');
        this.formErrors = [];
        this.showForm = true;
        this.formModel = response.data;
        this.formModel.id = id;
      }).finally(() => {
        this.updateLoading = false;
        this.$emit('updateExtOff');
        this.loadingModel.loading = false;
      });
    },
    updateExt() {
      this.saveLoading = true;
      this.$service({
        url: this.service + '/update-ext/' + this.phoneNumberId,
        method: 'put',
        data: {packageExts: this.formModel.packageExts}
      }).then(response => {
        this.showForm = false;
        if (response.data) {
          this.$swal({
            title: this.$t('success'),
            text: this.$t('updateExtSuccess'),
            icon: 'success'
          });
          this.$bus.$emit('reloadNumberList');
        } else {
          this.$swal({
            title: this.$t('error'),
            text: this.$t('updateExtFail'),
            icon: 'error'
          });
        }
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
          this.showForm = false;
        } else {
          this.formErrors = error.response.data;
        }
      }).finally(() => {
        this.saveLoading = false;
      });
    },
  }
}
</script>